import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import CommonModal from './Modal';
import { CraneDropdown } from '../../dropdowns/single/Crane';
import { GateDropdown } from '../../dropdowns/single/Gate';
import { MachineryDropdown } from '../../dropdowns/single/Machinery';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { SCHEDULE_TYPES } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';
import {
  isTimeInsideLimit,
  // convertMinToTime,
  // convertTimeToMin,
} from '../../../utilities/momentUtil';

/**
 * @description 禁止時間帯設定ダイアログ
 *              ゲート、揚重機、機材予定一覧画面で使用
 * @param {boolean} visible true: 表示, false, 非表示
 * @param {object} workTime 現場に設定されている作業時間
 * @param {array} disabledTimes 設定した禁止時間帯データ
 * @param {function} callbacks 禁止時間帯設定メソッド
 * @param {string} planType ゲート or 揚重機 or 機材
 * @param {string} idUsePlanName gate-passages or crane-uses or machinery-uses
 */
const DisableTime = props => {
  const {
    visible,
    workTime,
    disabledTimes,
    loadingDisabledTimes,
    callbacks,
    planType,
    idUsePlanName,
    scheduleLimitTimes,
  } = props;
  if (_.isEmpty(workTime)) {
    return null;
  }

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div id='modal-dialog-disable-time' className='modal show'>
            <div
              className='dialog-md dialog--modal'
              style={{ width: '620px', maxWidth: '620px' }}
            >
              <div className='dialog-md__header'>
                <span className='dialog-md__title'>禁止時間帯設定</span>
              </div>
              <div className='dialog-md__body'>
                {loadingDisabledTimes === true ? (
                  <div className='indicator' />
                ) : (
                  <div className='dialog-form'>
                    <div className='dialog-form__text'>
                      {messageUtility.getMessage('I-001-308')}
                    </div>
                    <div className='dialog-form__scroll dialog-form__scroll--full-page set-width-dropdown'>
                      {_.map(disabledTimes, (disabledTime, index) => (
                        <DisableTimeForm
                          key={index}
                          index={index}
                          disabledTime={disabledTime}
                          workTime={workTime}
                          callbacks={callbacks}
                          planType={planType}
                          idUsePlanName={idUsePlanName}
                          scheduleLimitTimes={scheduleLimitTimes}
                        />
                      ))}
                    </div>
                    <div className='dialog-form__item-center'>
                      <button
                        className='btn-fixedsize--sub'
                        onClick={() => callbacks.add()}
                      >
                        追加する
                      </button>
                    </div>
                    <div className='dialog-md__footer-horizontal'>
                      <button
                        id='modal-close-disable-time'
                        className='btn--sub'
                        onClick={() => callbacks.handleVisible('disableTime')}
                      >
                        戻る
                      </button>
                      <button
                        className={
                          // ドロップダウン項目を選択しない場合、更新ボタン押せない
                          _.some(disabledTimes, time => {
                            return time.target_id === '';
                          })
                            ? 'btn--effective btn--disabled'
                            : 'btn--effective'
                        }
                        disabled={_.some(disabledTimes, time => {
                          return time.target_id === '';
                        })}
                        onClick={() => callbacks.submit()}
                      >
                        更新
                      </button>
                    </div>
                    <div className='dialog-form__item-center'>
                      <a
                        href='javascript:void(0);'
                        className='btn-text--negative'
                        onClick={() => callbacks.handleVisible('confirmation')}
                      >
                        全ての禁止時間帯設定をクリア
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

/**
 * @description 禁止時間帯設定フォーム
 * @param {number} index 要素番号
 * @param {array} disabledTimes 設定した禁止時間帯データ
 * @param {object} workTime 現場に設定されている作業時間
 * @param {function} callbacks 禁止時間帯設定メソッド
 * @param {string} planType ゲート or 揚重機 or 機材
 * @param {string} idUsePlanName gate-passages or crane-uses or machinery-uses
 */
const DisableTimeForm = props => {
  const {
    index,
    disabledTime,
    scheduleLimitTimes,
    workTime,
    callbacks,
    planType,
    idUsePlanName,
  } = props;
  const workStartTime =
    workTime[SessionStorageService.getItem('work_hour_zone')].start;
  const workEndTime =
    workTime[SessionStorageService.getItem('work_hour_zone')].end;

  // 開始時間
  const startTime = () => {
    let start = moment(`${moment().format('YYYY/MM/DD')} ${workStartTime}`);
    let end = moment(`${moment().format('YYYY/MM/DD')} ${workEndTime}`);
    // 日またぎ
    if (end.isSameOrBefore(start)) {
      end.add(1, 'day');
    }

    let time = [];
    for (
      let target = start.clone();
      target.isBefore(end);
      target.add(15, 'minutes')
    ) {
      time.push(
        <option
          key={target.format('HH:mm:ss')}
          value={target.format('HH:mm:ss')}
          data-select={target.format('YYYY/MM/DD HH:mm:ss')}
        >
          {target.format('HH:mm')}
        </option>
      );
    }
    return time;
  };

  // 終了時間
  const endTime = () => {
    let start = moment(`${moment().format('YYYY/MM/DD')} ${workStartTime}`);
    let end = moment(`${moment().format('YYYY/MM/DD')} ${workEndTime}`);
    // 日またぎ
    if (end.isSameOrBefore(start)) {
      end.add(1, 'day');
    }
    start.add(15, 'minutes');

    // convertMinToTime(convertTimeToMin(currentFieldWorkTime.end) + 1440);

    let time = [];
    for (
      let target = start.clone();
      target.isSameOrBefore(end);
      target.add(15, 'minutes')
    ) {
      time.push(
        <option
          key={target.format('HH:mm:ss')}
          value={target.format('HH:mm:ss')}
          data-select={target.format('YYYY/MM/DD HH:mm:ss')}
        >
          {target.format('HH:mm')}
        </option>
      );
    }
    return time;
  };
  const style = {
    dialogForm: {
      show: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px 0',
      },
      hide: {
        display: 'none',
      },
    },
    dialogFormContents: {
      flex: '1 1 auto',
    },
    dialogFormItem: {
      padding: 8,
    },
    dialogFormLabel: {
      minWidth: 'initial',
    },
    RequireIcon: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0px 5px',
      borderRadius: 5,
      minWidth: 28,
      height: 18,
      background: 'red',
      color: 'white',
      fontSize: '0.7em',
      fontWeight: 'bolder',
    },
  };
  const {
    limit_start_time: limitStart,
    limit_end_time: limitEnd,
  } = scheduleLimitTimes[0];

  return (
    <div
      style={
        isTimeInsideLimit(
          disabledTime.limit_start_time,
          limitStart,
          limitEnd
        ) &&
        isTimeInsideLimit(disabledTime.limit_end_time, limitStart, limitEnd)
          ? style.dialogForm.show
          : style.dialogForm.hide
      }
    >
      <div className='dialog-form__contents' style={style.dialogFormContents}>
        <div className='dialog-form__item' style={style.dialogFormItem}>
          <div className='dialog-form__label' style={style.dialogFormLabel}>
            <span className='label'>{planType}</span>
            <span style={style.RequireIcon}>必須</span>
          </div>
          {planType === SCHEDULE_TYPES.gate.name && (
            <GateDropdown
              value={disabledTime.target_id}
              name={disabledTime.target_name}
              set={callbacks.dropdown}
              column={index}
              isDisableTime={true}
              readOnly={
                !isTimeInsideLimit(
                  disabledTime.limit_start_time,
                  limitStart,
                  limitEnd
                ) ||
                !isTimeInsideLimit(
                  disabledTime.limit_end_time,
                  limitStart,
                  limitEnd
                )
              }
              widthClass=''
            />
          )}
          {planType === SCHEDULE_TYPES.crane.name && (
            <CraneDropdown
              value={disabledTime.target_id}
              name={disabledTime.target_name}
              set={callbacks.dropdown}
              column={index}
              isDisableTime={true}
              readOnly={
                !isTimeInsideLimit(
                  disabledTime.limit_start_time,
                  limitStart,
                  limitEnd
                ) ||
                !isTimeInsideLimit(
                  disabledTime.limit_end_time,
                  limitStart,
                  limitEnd
                )
              }
              widthClass=''
            />
          )}
          {planType === SCHEDULE_TYPES.machinery.name && (
            <MachineryDropdown
              value={disabledTime.target_id}
              name={disabledTime.target_name}
              set={callbacks.dropdown}
              column={index}
              isNotNeedType={true}
              getMachineries={true}
              isDisableTime={true}
              readOnly={
                !isTimeInsideLimit(
                  disabledTime.limit_start_time,
                  limitStart,
                  limitEnd
                ) ||
                !isTimeInsideLimit(
                  disabledTime.limit_end_time,
                  limitStart,
                  limitEnd
                )
              }
              widthClass=''
            />
          )}
        </div>
        <div className='dialog-form__item' style={style.dialogFormItem}>
          <div className='dialog-form__label' style={style.dialogFormLabel}>
            <span className='label'>開始時間</span>
          </div>
          <div className='dialog-form__element'>
            <select
              className='dialog-form__time-select'
              name='limit_start_time'
              id={`${idUsePlanName}-limit-start-time-${index}`}
              value={disabledTime.limit_start_time}
              onChange={e => callbacks.set(e, index)}
              disabled={
                !isTimeInsideLimit(
                  disabledTime.limit_start_time,
                  limitStart,
                  limitEnd
                )
              }
            >
              {startTime()}
            </select>
          </div>
        </div>
        <div className='dialog-form__item' style={style.dialogFormItem}>
          <div className='dialog-form__label' style={style.dialogFormLabel}>
            <span className='label'>終了時間</span>
          </div>
          <div className='dialog-form__element'>
            <select
              className='dialog-form__time-select'
              name='limit_end_time'
              id={`${idUsePlanName}-limit-end-time-${index}`}
              value={disabledTime.limit_end_time}
              onChange={e => callbacks.set(e, index)}
              disabled={
                !isTimeInsideLimit(
                  disabledTime.limit_end_time,
                  limitStart,
                  limitEnd
                )
              }
            >
              {endTime()}
            </select>
          </div>
        </div>
      </div>
      <button
        className='btn-form-item-delete'
        onClick={() => callbacks.remove(index)}
      >
        <i className='i-close i-3x' />
      </button>
    </div>
  );
};

export default DisableTime;



// WEBPACK FOOTER //
// ./src/components/modals/common/DisableTime.jsx